import PhaseContext from 'components/ChallengePortfolio/NormalView/PhaseContext';
import Phases from 'lib/constants/Phases';

const PretendDonePhaseForCorrectChallengeDisplay = props => (
  <PhaseContext.Provider value={Phases.DONE} {...props} />
);

export default PretendDonePhaseForCorrectChallengeDisplay;
